module.exports = __webpack_public_path__ + "static/img/wx_ch.97ca3de.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/honggu/wx_ch.png
// module id = CeWa
// module chunks = 0